<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ft8nEm/tc-custom/9781452129853.jpg?1720831243008" alt="This image is the cover for the book Southern Casseroles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Southern Casseroles
      </h1>
      <p class="bookDescription body article font2">
        <b>With these fifty-five satisfying recipes, this classic Southern comfort food brings the heartwarming flavor of home to any family meal or friendly gathering.</b><br/><br/>This tantalizing cookbook brings the irresistible charm of Southern culture to the dinner table by way of mouthwatering casserole dishes. Denise Gee presents fifty-five beloved classic and contemporary casserole recipes bubbling with traditions that stretch from the Bayou to the lower Appalachian Mountains.<br/><br/>To complement the chapters covering basics, easy recipes, party recipes, and side dishes, dozens of luscious photos showcase the delicious attributes of a perfect casserole. <i>Southern Casseroles</i> brings together the tried-and-true casseroles of the South and the endearing stories behind them.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Denise Gee, Robert M. Peacock
      </h2>
      
      <p class="authorDescription body article">Denise Gee is the author of Porch Parties, Southern Cocktails, and Sweet on Texas. She lives in Dallas, Texas.Robert Peacock is a Dallas-based photographer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f097ab38